import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z","key":"svg-0"}]]

const IconCircleFilled = createReactComponent('filled', 'circle-filled', 'CircleFilled', __iconNode);

export default IconCircleFilled;